import { useQuery } from '@tanstack/react-query';
import { getAccountDetails } from '@api/account';

export type Details = {
  features: {
    name: string;
    value: any;
  }[];
};

export const useAccountDetails = (mode: string) => {
  const response = useQuery(
    ['get-account-details', mode],
    () => {
      return getAccountDetails<Details>({
        params: {
          mode,
        },
      });
    },
    {
      retry: 3,
      refetchOnWindowFocus: false,
      staleTime: 5 * 60 * 1000, // 5m
    },
  );

  return response;
};
